<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group>
      <mat-tab label="Senders">
        <ng-template matTabContent>
          <div class="px-4">
            <div class="d-flex justify-content-between pt-1 my-1">
              <form
                [formGroup]="filterForm"
                class="mat-form d-flex align-items-center gap-10">
                <app-input-select
                  *appHasPlatformAccess
                  (selectionChange)="applyFilter()"
                  [inputData]="attrConstant.partner"
                  [selectOptions]="partnerList | async"
                  [bindLabel]="'name'"
                  [bindValue]="'partner_id'"
                  [formControlName]="
                    attrConstant.partner.key
                  "></app-input-select>
                <app-input-template
                  (keyup)="applyFilter()"
                  [inputData]="attrConstant.search"
                  [formControlName]="
                    attrConstant.search.key
                  "></app-input-template>
                <img
                  src="assets/images/clear-filter.svg"
                  class="clear-img"
                  alt="clear-filter"
                  matTooltip="Clear Filters"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="clearFilters()" />
              </form>
              <div class="d-flex align-items-center gap-10">
                <img
                  src="assets/images/reload.svg"
                  alt="reload"
                  class="reload-img"
                  matTooltip="Reload"
                  matTooltipPosition="above"
                  [attr.aria-hidden]="true"
                  (click)="reload()" />
                <button class="btn primary-btn" (click)="export()">
                  Export
                </button>
                <button class="btn primary-btn" (click)="openReport()">
                  Report
                </button>
              </div>
            </div>
            <table
              mat-table
              matSort
              [matSortActive]="activeSort?.active ?? 'created_at'"
              [matSortDirection]="activeSort?.direction ?? 'desc'"
              [dataSource]="dataSource"
              (matSortChange)="onSortChange($event)">
              <!-- Name Column -->
              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let element" data-label="Name">
                  {{ element.first_name }} {{ element.middle_name }}
                  {{ element.last_name }}
                </td>
              </ng-container>

              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let element" data-label="Email">
                  <ng-container *ngIf="!element.isDummyEmail">
                    {{ element.email }}
                  </ng-container>
                </td>
              </ng-container>

              <!-- DOB Column -->
              <ng-container matColumnDef="date_of_birth">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>DOB</th>
                <td mat-cell *matCellDef="let element" data-label="DOB">
                  {{ element.date_of_birth }}
                </td>
              </ng-container>

              <!-- Country Column -->
              <ng-container matColumnDef="source_country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Country
                </th>
                <td mat-cell *matCellDef="let element" data-label="Country">
                  {{ element.source_country }}
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let element" data-label="Status">
                  {{ element.status }}
                </td>
              </ng-container>

              <!-- Nationality Column -->
              <ng-container matColumnDef="nationality">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nationality
                </th>
                <td mat-cell *matCellDef="let element" data-label="Nationality">
                  {{ element.nationality !== '' ? element.nationality : '--' }}
                </td>
              </ng-container>

              <!-- Mobile Number Column -->
              <ng-container matColumnDef="mobile_number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Mobile Number
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Mobile Number">
                  {{ element.mobile_number }}
                </td>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>
                  <ng-container *appHasAccess="'/sender/edit/:id'">
                    Action
                  </ng-container>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  data-label="Action"
                  (click)="$event.stopPropagation()">
                  <img
                    *appHasAccess="'/sender/edit/:id'"
                    src="assets/images/edit-icon.svg"
                    alt="edit-icon"
                    class="reload-img"
                    matTooltip="Edit"
                    matTooltipPosition="right"
                    [routerLink]="[
                      '/sender/edit',
                      isSuperAdmin
                        ? element.sender_id + '-' + element.partner_id
                        : element.sender_id,
                    ]" />
                  <button
                    *appHasAccess="'\sender\edit:id'"
                    mat-icon-button
                    [matMenuTriggerFor]="rowActionsMenu"
                    matTooltip="Actions"
                    matTooltipPosition="right">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <mat-menu #rowActionsMenu="matMenu">
                    <button mat-menu-item (click)="onToggleActive(element)">
                      {{ element.is_active ? 'Deactivate' : 'Activate' }} Sender
                    </button>
                    <button mat-menu-item (click)="onUpdateKyc(element)">
                      Update KYC Status
                    </button>
                    <button mat-menu-item (click)="onUpdateAml(element)">
                      Update AML Status
                    </button>
                  </mat-menu>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                class="custom-mat-btn"
                *matRowDef="let row; columns: displayedColumns; let element"
                [routerLink]="[
                  '/sender/details',
                  isSuperAdmin
                    ? element.sender_id + '-' + element.partner_id
                    : element.sender_id,
                ]"></tr>
            </table>
            <mat-paginator
              showFirstLastButtons
              [pageIndex]="page"
              [length]="total"
              [pageSize]="limit"
              [pageSizeOptions]="[10, 20, 50, 100, 200]"
              (page)="onPageChange($event)"></mat-paginator>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab disabled>
        <ng-template mat-tab-label>
          <button
            class="btn primary-btn"
            [routerLink]="['/sender/add']"
            *appHasAccess="'/sender/add'">
            Add sender
          </button>
          <button
            class="btn primary-btn ms-2"
            [routerLink]="['/sender/upload']"
            *appHasAccess="'/sender/upload'">
            Upload senders
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
